export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8355.90a4b22f.jpg";